<template>
  <div
    v-if="userHasPermission(constants.PERMISSION_TYPES.PROBLEM_REPORT, constants.PERMISSION_VALUES.CREATE)"
    :class="{'spl-modal-holder-show': isVisible}"
    class="spl-modal-holder spl-create-problem-report"
    @click.self="closeModal">
    <div class="spl-modal">
      <div class="spl-modal__label">
        Report a Problem
      </div>

      <div class="spl-modal__close" @click="closeModal" />

      <form-label>Who is responsible?</form-label>
      <form-filtered-select
        :selected-key="problem_report_model.Problem_Responsible_Type_ID.value"
        :options="responsibleTypeOptions"
        :invalid="$v.problem_report_model.Problem_Responsible_Type_ID.value.$error"
        class="spl-create-problem-report__responsible"
        @close="$v.problem_report_model.Problem_Responsible_Type_ID.value.$touch()"
        @updateDropdownValue="update_selections" />
      <span v-if="$v.problem_report_model.Problem_Responsible_Type_ID.value.$error" class="error">A Responsible entity is required.</span>
      <br>

      <form-label v-if="problemTypeOptions.length> 0">
        What type of problem?
      </form-label>
      <form-filtered-select
        v-if="problemTypeOptions.length> 0"
        ref="problemType"
        :options="problemTypeOptions"
        :selected-key="problem_report_model.Problem_Type_ID.value"
        :invalid="$v.problem_report_model.Problem_Type_ID.value.$error"
        class="spl-create-problem-report__problem-type"
        @close="$v.problem_report_model.Problem_Type_ID.value.$touch()"
        @updateDropdownValue="updateProblemType" />
      <span v-if="$v.problem_report_model.Problem_Type_ID.value.$error" class="error">The Problem Type is required.</span>
      <br>

      <form-label v-if="responsibleProvidersOptions.length > 0">
        Which providers fault?
      </form-label>
      <form-filtered-select
        v-if="responsibleProvidersOptions.length > 0"
        ref="problemResponsible"
        :options="responsibleProvidersOptions"
        :value="problem_report_model.Responsible_ID.value"
        class="spl-create-problem-report__responsible-provider"
        @updateDropdownValue="updateProblemResponsible" />
      <br>

      <form-label>When is the new estimated delivery?</form-label>
      <form-datepicker
        v-model="problem_report_model.Estimated_Delivery_Time"
        type="datetime"
        min="2009-01-01"
        class="spl-create-problem-report__estimated-delivery" />

      <br>

      <form-label>Anything to add?</form-label>
      <form-textarea
        v-model="problem_report_model.Problem_Freetext"
        class="spl-create-problem-report__note"
        placeholder="Please don't fill any personal or subjective information in this field" />
      <br>

      <form-checkbox v-if="sms_possible" @checkboxChanged="updateSendSMS">
        Send&nbsp;SMS
      </form-checkbox>
      <br>
      <form-checkbox
        :checked="deactivate_problem_reports"
        @checkboxChanged="updateDeactivateProblemReports">
        Deactivate previous problem reports
      </form-checkbox>
      <br>
      <div class="row">
        <div class="col6">
          <form-button
            :wide="true"
            :secondary="true"
            class="spl-create-problem-report__cancel"
            @onClick="closeModal">
            Cancel
          </form-button>
        </div>
        <div class="col6">
          <form-button
            :wide="true"
            :disabled="$v.$invalid"
            class="spl-create-problem-report__submit"
            @onClick="submitModal">
            Save
          </form-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import webApi from '@/webApi'
import constants from '@/constants'
import Helpers from '@/helpers'
import { mapState, mapActions } from 'vuex'
import { required, minValue } from 'vuelidate/lib/validators'

export default {
  name: 'CreateProblemReportModel',
  mixins: [Helpers],
  props: ['selectedRows'],
  data () {
    return {
      isVisible: false,
      problem_type_list: [],
      problem_responsible_list: [],
      constants,
      sendSMS: false,
      parcel_ids: '',
      parcel_id_list: [],
      sms_possible: false,
      deactivate_problem_reports: true,
      problem_report_model: {
        Problem_Responsible_Type_ID: { label: 'Select', value: 0 },
        Responsible_ID: { label: 'Select', value: 0 },
        Problem_Type_ID: { label: 'Select', value: 0 },
        Problem_Freetext: '',
        Estimated_Delivery_Time: ''
      }
    }
  },
  computed: {
    ...mapState('problemReport', ['responsibleTypeOptions', 'problemTypeOptions', 'responsibleProvidersOptions'])
  },
  validations: {
    problem_report_model: {
      Problem_Type_ID: {
        value: {
          required,
          minValue: minValue(1)
        }
      },
      Problem_Responsible_Type_ID: {
        value: {
          required,
          minValue: minValue(1)
        }
      }
    }
  },
  created () {
  },
  mounted () {
    // Modal was opened
    window.bus.$on('openCreateProblemReportModal', this.checkProblemReports)
  },
  beforeDestroy () {
    window.bus.$off('openCreateProblemReportModal', this.checkProblemReports)
  },
  methods: {
    ...mapActions('problemReport', ['loadProblemTypeList', 'loadResponsibleProviders']),
    checkProblemReports () {
      // Get the parcel IDs
      this.sms_possible = false
      this.parcel_ids = ''
      this.parcel_id_list = []
      this.selectedRows.forEach((item, index) => {
        if (this.parcel_ids !== '') this.parcel_ids += ','
        this.parcel_ids += this.selectedRows[index].Parcel_ID
        this.parcel_id_list.push(this.selectedRows[index].Parcel_ID)
      })
      // Check if SMS is possible for parcel list
      webApi.problem_report.check_If_SMS_Possible_For_Problem_Report(this.parcel_id_list)
        .then((response) => {
          // Success
          this.sms_possible = response.data
        }).catch((response) => {
        // Failure
          window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
        })
      this.isVisible = true
      this.problem_report_model.Problem_Responsible_Type_ID = { label: 'Select', value: 0 }
      this.problem_report_model.Responsible_ID = { label: 'Select', value: 0 }
      this.problem_report_model.Problem_Type_ID = { label: 'Select', value: 0 }
      this.problem_report_model.Problem_Freetext = ''
      this.problem_report_model.Estimated_Delivery_Time = ''
    },
    updateSendSMS (isChecked) {
      this.sendSMS = isChecked
    },
    updateDeactivateProblemReports (isChecked) {
      this.deactivate_problem_reports = isChecked
    },
    // Close the scan window
    closeModal () {
      this.isVisible = false
    },

    //* ******************** Submit the modal ****************
    // Will scan a new event or update an existing one
    submitModal () {
      var newProblemReportModel = {
        Problem_Responsible_Type_ID: this.problem_report_model.Problem_Responsible_Type_ID.value,
        Responsible_ID: this.problem_report_model.Responsible_ID.value,
        Problem_Type_ID: this.problem_report_model.Problem_Type_ID.value,
        Problem_Freetext: this.problem_report_model.Problem_Freetext,
        Estimated_Delivery_Time: this.problem_report_model.Estimated_Delivery_Time,
        Send_SMS: this.sendSMS,
        Parcel_IDs: this.parcel_ids,
        Parcel_ID_List: this.parcel_id_list,
        Deactivate_Problem_Reports: this.deactivate_problem_reports
      }

      // Call the server
      webApi.problem_report.create_Problem_Report_For_Parcel_List(newProblemReportModel)
        .then((response) => {
          // Success
          if (this.sendSMS) {
            this.$toast('Problem Report for the selected parcels was created and SMS send.', constants.defaultToastOptions())
          } else {
            this.$toast('Problem Report for the selected parcels was created.', constants.defaultToastOptions())
          }

          this.$emit('problemReportCreated')
          this.closeModal()
        }).catch((response) => {
          // Failure
          window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
        })
    },

    // When the problem responsible type change, we need to reload the other two selections
    update_selections (problemResponsibleType) {
      this.problem_report_model.Problem_Responsible_Type_ID = problemResponsibleType
      if (this.$refs.problemType) {
        this.$refs.problemType.reset()
      }
      if (this.$refs.problemResponsible) {
        this.$refs.problemResponsible.reset()
      }
      this.get_Problem_Type_List(problemResponsibleType)
      this.get_Problem_Responsible_List(problemResponsibleType)
    },

    updateProblemResponsible (value) {
      this.problem_report_model.Responsible_ID = value
    },

    updateProblemType (value) {
      this.problem_report_model.Problem_Type_ID = value
    },

    // ************************ Load the problem types ************************
    get_Problem_Type_List (problemResponsibleType) {
      this.problem_report_model.Problem_Type_ID = { label: 'Select', value: 0 }
      this.loadProblemTypeList(problemResponsibleType.value)
    },

    // ************************ Load the  responsible list ************************
    get_Problem_Responsible_List (problemResponsibleType) {
      this.problem_report_model.Responsible_ID = { label: 'Select', value: 0 }
      this.loadResponsibleProviders(problemResponsibleType.value)
    }

  }
}
</script>

<style lang="scss">
</style>
